

import billingDashboardRoutes from "./bilingDashboard";
import developersRoutes from "./developers";
import roadcubeMarketRoutes from "./roadcubeMarket";



export default [
    {
        path: "billing-dashboard",
        name: "BillingDashboard", 
        meta:{
            permissionPath: 'general_settings.billing_dashboard.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "billingDashboard" */ "@/views/general/settings/billingDashboard"
            ),

        children: billingDashboardRoutes
    },
    {
        path: "developers",
        name: "Developers",
        meta:{
            permissionPath: 'developers.read',
        },
        component: () =>
            import(
                /* webpackChunkName: "developers" */ "@/views/general/settings/developers"
            ),

        children: developersRoutes
    },
    {
        path: "roadcube-market",
        name: "RoadcubeMarket",
        component: () =>
            import(
                /* webpackChunkName: "roadcubeMarket" */ "@/views/general/settings/roadcubeMarket"
            ),

        children: roadcubeMarketRoutes
    }
];
